import { qs, qsa } from '../core/dom.js';

function setNavLinkActive(link, on) {
	link.classList.toggle('is-active', on);
	if (on) {
		link.setAttribute('aria-current', 'true');
	} else {
		link.removeAttribute('aria-current');
	}
}

function getNavSectionIds(link) {
	const group = link.dataset.navGroup?.trim();
	if (group) {
		return group.split(',').map((id) => id.trim()).filter(Boolean);
	}

	const section = link.dataset.navSection?.trim();
	return section ? [section] : [];
}

function initNavActive() {
	const navLinks = qsa('[data-nav-section]').filter((link) => !link.classList.contains('head-cta'));
	const ctaLink = qs('.head-cta[data-nav-section]');
	const isHome = document.body.classList.contains('home');

	if (!navLinks.length && !ctaLink) return;

	const sectionIds = [...new Set(
		[...navLinks, ...(ctaLink && isHome ? [ctaLink] : [])].flatMap(getNavSectionIds),
	)];

	const sections = sectionIds
		.map((id) => document.getElementById(id))
		.filter(Boolean);

	if (!sections.length) return;

	const header = qs('.site-head');

	const update = () => {
		const offset = (header?.offsetHeight ?? 80) + 8;
		let current = '';

		sections.forEach((section) => {
			if (section.getBoundingClientRect().top <= offset) {
				current = section.id;
			}
		});

		navLinks.forEach((link) => {
			const ids = getNavSectionIds(link);
			setNavLinkActive(link, current !== '' && ids.includes(current));
		});

		if (ctaLink && isHome) {
			setNavLinkActive(ctaLink, current !== '' && getNavSectionIds(ctaLink).includes(current));
		} else if (ctaLink) {
			setNavLinkActive(ctaLink, false);
		}
	};

	window.addEventListener('scroll', update, { passive: true });
	window.addEventListener('resize', update, { passive: true });
	update();
}

export function initLprSite() {
	const burger = qs('#burger');
	const drawer = qs('#drawer');
	const drawerShell = qs('#drawer-shell');

	if (burger && drawer && drawerShell) {
		const setDrawerOpen = (open) => {
			drawer.classList.toggle('open', open);
			drawerShell.classList.toggle('is-open', open);
			burger.classList.toggle('open', open);
			burger.setAttribute('aria-expanded', open ? 'true' : 'false');
			drawerShell.setAttribute('aria-hidden', open ? 'false' : 'true');
			drawer.inert = !open;
		};

		const mobileNavQuery = window.matchMedia('(max-width: 1140px)');

		const handleMobileNavBreakpoint = () => {
			if (!mobileNavQuery.matches) {
				setDrawerOpen(false);
			}
		};

		setDrawerOpen(false);

		burger.addEventListener('click', () => {
			setDrawerOpen(!drawer.classList.contains('open'));
		});

		qsa('a', drawer).forEach((link) => {
			link.addEventListener('click', () => {
				setDrawerOpen(false);
			});
		});

		document.addEventListener('keydown', (event) => {
			if (event.key !== 'Escape' || !drawer.classList.contains('open')) return;
			setDrawerOpen(false);
			burger.focus();
		});

		mobileNavQuery.addEventListener('change', handleMobileNavBreakpoint);
	}

	initNavActive();
}
